function cov_2hhwv5jyvm() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/DateSubtractFilled.tsx";
  var hash = "553e106b6704174eb13088af4b2501f624fba41b";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/DateSubtractFilled.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 60
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "553e106b6704174eb13088af4b2501f624fba41b"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2hhwv5jyvm = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2hhwv5jyvm();
var Icon = (cov_2hhwv5jyvm().s[0]++, {
  name: 'date-subtract-filled',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.25 3.25C8.25 2.55964 7.69036 2 7 2C6.30964 2 5.75 2.55964 5.75 3.25V4.25H5C3.34315 4.25 2 5.59315 2 7.25V19.25C2 20.9069 3.34315 22.25 5 22.25H19C20.6569 22.25 22 20.9069 22 19.25V7.25C22 5.59315 20.6569 4.25 19 4.25H18.25V3.25C18.25 2.55964 17.6904 2 17 2C16.3096 2 15.75 2.55964 15.75 3.25V4.25H8.25V3.25ZM5 9.25C4.44772 9.25 4 9.69772 4 10.25C4 10.8023 4.44772 11.25 5 11.25H19C19.5523 11.25 20 10.8023 20 10.25C20 9.69772 19.5523 9.25 19 9.25H5ZM15.25 15.75C15.25 16.4404 14.6904 17 14 17H10C9.30964 17 8.75 16.4404 8.75 15.75C8.75 15.0596 9.30964 14.5 10 14.5H14C14.6904 14.5 15.25 15.0596 15.25 15.75Z\" fill=\"currentColor\"/>"
});
export default Icon;